/**
 * Get the display name for an accommodation
 * @param {Object} accommodation - The accommodation object
 * @returns {string} The display name or fallback to name
 */
export const getAccommodationDisplayName = (accommodation) => {
  return accommodation.name;
};

/**
 * Sort accommodations lexicographically by display name
 * @param {Array} accommodations - Array of accommodation objects
 * @returns {Array} Sorted array of accommodations
 */
export const sortAccommodationsAlphabetically = (accommodations) => {
  return [...accommodations].sort((a, b) => {
    const nameA = getAccommodationDisplayName(a).toLowerCase();
    const nameB = getAccommodationDisplayName(b).toLowerCase();
    return nameA.localeCompare(nameB);
  });
};

/**
 * Sort accommodations by price (ascending)
 * @param {Array} accommodations - Array of accommodation objects
 * @returns {Array} Sorted array of accommodations
 */
export const sortAccommodationsByPrice = (accommodations) => {
  return [...accommodations].sort((a, b) => a.price_per_night - b.price_per_night);
};

/**
 * Get featured accommodations (cheapest 3)
 * @param {Array} accommodations - Array of accommodation objects
 * @param {number} count - Number of featured accommodations to return (default: 3)
 * @returns {Array} Array of featured accommodations
 */
export const getFeaturedAccommodations = (accommodations, count = 3) => {
  return sortAccommodationsByPrice(accommodations).slice(0, count);
};
